import { Group } from '@mantine/core';
import { IconChevronsRight, IconFileDescription, IconMail, IconRotateRectangle, IconSignature } from '@tabler/icons';
import { FC } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useNavigationItem } from '../../../Organismns/Navigation/NavigationItemHook';
import { useBookitupScope } from '../../../Service/Context/BookitupSubscriptionContext';
import ActionIconWithText from './ActionIconWithText';

interface HandlersProps {
  openNavBar: () => void;
}

const SettingsFooter: FC<HandlersProps> = ({ openNavBar }) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { isScopeSelected: hasSettingsScope } = useBookitupScope('SETTINGS');
  const { isScopeSelected: hasDocumentsScope } = useBookitupScope('DOCUMENTS');
  const { isScopeSelected: hasEmailScope } = useBookitupScope('EMAILS');
  const showMiddleIcon = !pathname.endsWith('positions');
  const messagesActive = useNavigationItem(`/settings/messages`);
  const templatesActive = useNavigationItem(`/settings/templates`);
  const contractsActive = useNavigationItem(`/settings/contracts`);
  const workflowActive = useNavigationItem(`/settings/workflow`);

  return (
    <Group px="xl" pt={5} sx={{ justifyContent: 'space-between' }}>
      <ActionIconWithText useDefaultWidth label="Alle" onClick={openNavBar}>
        <IconChevronsRight />
      </ActionIconWithText>
      {hasSettingsScope && hasEmailScope && (
        <ActionIconWithText
          useDefaultWidth
          label="Emails"
          active={messagesActive}
          onClick={() => navigate(`/settings/messages`)}
        >
          <IconMail />
        </ActionIconWithText>
      )}

      {(hasSettingsScope && hasDocumentsScope && showMiddleIcon) ? (
        <ActionIconWithText
          useDefaultWidth
          label="Dokumente"
          active={templatesActive}
          onClick={() => navigate(`/settings/templates`)}
        >
          <IconFileDescription />
        </ActionIconWithText>
      ) : (
        <div style={{ width: '10%' }} />
      )}

      {hasSettingsScope && hasDocumentsScope && (
        <ActionIconWithText
          useDefaultWidth
          label="Verträge"
          active={contractsActive}
          onClick={() => navigate(`/settings/contracts`)}
        >
          <IconSignature />
        </ActionIconWithText>
      )}
      {hasSettingsScope && (
        <ActionIconWithText
          useDefaultWidth
          label="Workflows"
          active={workflowActive}
          onClick={() => navigate(`/settings/workflow`)}
        >
          <IconRotateRectangle size={16} />
        </ActionIconWithText>
      )}
    </Group>
  );
};

export default SettingsFooter;
